import { useQuery, UseQueryOptions } from 'react-query';
import { getProductScope } from '@discover-frontend/utils';

import { STANLEY_QUERY_KEYS } from '../constants';
import { fetchStanleyQueryHistoryItem } from '../request';
import { StanleyQueryHistoryItemResponse } from '../types';

export const useStanleyQueryHistoryItem = (
  runId: string | null | undefined,
  options?: Omit<
    UseQueryOptions<StanleyQueryHistoryItemResponse>,
    'queryKey' | 'queryFn' | 'enabled'
  > & { enabled?: boolean }
) => {
  const scope = getProductScope();
  const { enabled: enabledFromOptions, ...queryOptions } = options ?? {};

  return useQuery<StanleyQueryHistoryItemResponse>(
    [STANLEY_QUERY_KEYS.GET_HISTORY_ITEM, scope, runId],
    () => fetchStanleyQueryHistoryItem(runId as string),
    {
      // History runs are immutable for a given run_id — avoid refetch on revisit.
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      cacheTime: 1000 * 60 * 60,
      ...queryOptions,
      enabled:
        Boolean(runId) && (enabledFromOptions ?? true),
    }
  );
};
